<template>
  <div>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="type" label="类型" align="center" width="60">
        </el-table-column>
        <el-table-column prop="url" label="url" align="center">
        </el-table-column>
        <el-table-column prop="name" label="名字" align="center">
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="dec" label="描述" align="center">
        </el-table-column>
        <el-table-column prop="key_word" label="关键词" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="opration-item" @click="toEditCase(scope.row)"
                >编辑</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <common-pagination
        :total="total"
        :page_size="page_size"
        @size-change="handelPagesizeChange"
        @page-change="handlePageChange"
      ></common-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonPagination from "@/components/CommonPagination";
import { getSettingSEOList } from "@/api/tdk";

export default {
  name: "tdkManage",
  data() {
    return {
      tableData: [],
      page_index: "1", //第几页
      page_size: "10",
      total: 0, //总条数
    };
  },
  computed: {
    ...mapState(["imgDomain"]),
  },
  mounted() {
    this._getSeoList();
  },
  components: {
    CommonPagination,
  },
  methods: {
    async _getSeoList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size,
      };
      const { data, status } = await getSettingSEOList(postData);
      if (status !== 200) return;
      this.tableData = data.result.data;
      this.total = data.result.total;
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this._getSeoList();
    },
    handlePageChange(page) {
      this.page_index = page;
      this._getSeoList();
    },
    toEditCase(row) {
      this.$router.push({
        path: "/tdk-handle",
        query: {
          uuid: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
.btns-wrap {
  display: flex;
  justify-content: space-between;
}
.table-wrap {
  margin-top: 40px;
  margin-bottom: 40px;
  .project-img {
    width: 100%;
    max-height: 300px;
  }
}
.operation-wrap {
  display: flex;
  justify-content: space-around;
  color: @color-text;
  .opration-item {
    cursor: pointer;
  }
}
.dialog-body-wrap {
  text-align: center;
}
/deep/.el-table__row {
  height: 200px;
}
</style>
